export const v1 = 'v1';
export const v2 = 'v2';
export const currentVersion = v1;
